<template>
    <el-drawer
        title="对应角色"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="loading">
            <el-row :gutter="40">
                <el-col v-for="(item,index) in dataList" :key="index" :span="12" class="MT20">
                    <el-link  :href="`/system/role/list?roleName=${item}`">{{item}}</el-link>
                </el-col>
            </el-row>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关 闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        return {
            drawerShow: false,
            loading: false,
            id: '',
            dataList: []
        };
    },
    methods: {
        close() {
            this.dataList = []
            this.drawerShow = false;
        },
        show(id) {
            this.id = id;
            this.getData();
            this.drawerShow = true;
        },
        getData() {
            this.loading = true;
            this.$request({
                url: '/adminPrivilege/correspondingRole',
                params: {id: this.id},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.dataList = result;
                    } else {
                        this.$message.error(msg || "获取失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取失败,请重试");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>